import { PolicyResultStatus } from '@40seas/entities/underwriting';
import { EnumColor } from '@40seas/frontend/common/providers';

export const policyResultStatusColorMapping = {
    [PolicyResultStatus.Unqualified]: 'error',
    [PolicyResultStatus.Qualified]: 'success',
} as { [key in PolicyResultStatus]: EnumColor };
